/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, makeStyles, Typography } from '@material-ui/core';
import TableItems, { TableCell, TableRow } from 'components/TableItems';
import i18n from 'i18n';
import { getLeakedCredentialsUsersClientsRequest } from 'modules/partners/actions';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import { useTableFilters } from 'hooks/useTableFilters';
import { SearchBar } from 'components/SearchBar';
import {
  LeakedCredentialsUsersClientsFields,
  LeakedCredentialsUsersClientsProps,
} from 'modules/partners/interfaces';
import { cyrb53Hash } from 'utils/helpers';
import styles from './styles';

const useStyles = makeStyles(styles);

const initialQuery = {
  offset: 0,
  limit: 25,
  search: '',
};

interface Props {
  isLoading: boolean;
  leakedCredentialsUsersClients: LeakedCredentialsUsersClientsProps;
  userUuid: string;
  getLeakedCredentialsUsersClientsRequest: (props) => void;
}

const ListClients = ({
  isLoading,
  leakedCredentialsUsersClients,
  userUuid,
  getLeakedCredentialsUsersClientsRequest,
}: Props) => {
  const classes = useStyles();

  const {
    itemOrder,
    query,
    searchValue,
    handleOrder,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    setSearchValue,
  } = useTableFilters(initialQuery);

  const headers = [
    {
      key: 'name',
      i18n: 'CLIENT_KEY',
      order: true,
    },
    {
      key: 'environment',
      i18n: 'ENVIRONMENT_KEY',
      order: true,
    },
    {
      key: 'is_sso_enabled',
      i18n: 'SSO_ACTIVE_KEY',
      order: true,
      centerTitle: true,
    },
    {
      key: 'user_mfa_is_active',
      i18n: 'MFA_ACTIVE_KEY',
      order: true,
      centerTitle: true,
    },
  ];

  const getClients = () => {
    getLeakedCredentialsUsersClientsRequest({
      query,
      id: userUuid,
    });
  };

  React.useEffect(() => {
    getClients();
  }, [getLeakedCredentialsUsersClientsRequest, query, userUuid]);

  return (
    <Grid container>
      <Grid container>
        <SearchBar
          id="search-clients"
          isLoading={isLoading}
          searchValue={searchValue}
          placeholder={i18n.t('SEARCH_KEY')}
          handleSearch={handleSearch}
          setSearchValue={setSearchValue}
        />
        <TableItems
          header={
            <>
              {headers.map(item => (
                <TableCell
                  centerTitle={item?.centerTitle}
                  key={item?.key}
                  order={item?.order}
                  markOderItem={itemOrder === item?.key}
                  handleOrder={() =>
                    item?.order ? handleOrder(item?.key) : null
                  }
                >
                  {i18n.t(item?.i18n)}
                </TableCell>
              ))}
            </>
          }
          renderItems={(item: LeakedCredentialsUsersClientsFields, index) => (
            <TableRow key={cyrb53Hash(index)}>
              <TableCell copyable className={classes.textField}>
                {item?.name}
              </TableCell>
              <TableCell copyable className={classes.textField}>
                {item?.environment?.name}
              </TableCell>
              <TableCell className={classes.textFieldCenter}>
                <Typography className={classes.textFieldCenterText}>
                  {item?.is_sso_enabled ? i18n.t('YES_KEY') : i18n.t('NO_KEY')}
                </Typography>
              </TableCell>
              <TableCell className={classes.textFieldCenter}>
                <Typography className={classes.textFieldCenterText}>
                  {item?.user_mfa_is_active
                    ? i18n.t('YES_KEY')
                    : i18n.t('NO_KEY')}
                </Typography>
              </TableCell>
            </TableRow>
          )}
          data={leakedCredentialsUsersClients}
          isLoading={isLoading}
          onChangePage={handlePageChange}
          onChangeLimit={handleLimitChange}
          notFoundText={i18n.t('LOGS_PAGE.NO_LOGS_KEY')}
        />
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({
  partners: {
    leakedCredentialsUsersClients,
    isLoadingLeakedCredentialsUsersClients,
  },
}: ApplicationState) => ({
  leakedCredentialsUsersClients,
  isLoading: isLoadingLeakedCredentialsUsersClients,
});

export default connect(mapStateToProps, {
  getLeakedCredentialsUsersClientsRequest,
})(ListClients);
